/** Keys mirrored from apps/api/.../crm/fields.go humanFieldKeys. */
export const CRM_HUMAN_FIELD_KEYS = [
  'partner',
  'partner_commission',
  'advertising',
  'call_recording',
  'lead_bucket',
  'lead_source',
  'ad_id',
  'ad_set_id',
  'campaign_name',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_referrer',
] as const;

export type CrmHumanFieldKey = (typeof CRM_HUMAN_FIELD_KEYS)[number];

/** Keys hidden on card details (marketing / contact-owned). */
export function isHiddenCrmField(key: string): boolean {
  if (
    key === 'partner' ||
    key === 'partner_commission' ||
    key === 'advertising' ||
    key === 'call_recording' ||
    key === 'dialog_summary' ||
    key === 'channel' ||
    key === 'email'
  ) {
    return true;
  }
  const upper = key.toUpperCase().replaceAll('-', '_');
  return upper.startsWith('AD_') || upper.startsWith('CAMPAIGN') || upper.startsWith('UTM');
}

/** Human fields shown on CRM card / chat details (structured meta only). */
export const CRM_CARD_FIELD_KEYS = CRM_HUMAN_FIELD_KEYS.filter((key) => !isHiddenCrmField(key));
